export default "__VITE_ASSET__DrMOyvN4__"